import React from "react";

interface PageStateProps {
  text: string;
  tone?: "default" | "error";
}

export function PageState({ text, tone = "default" }: PageStateProps) {
  return (
    <div
      className={`space-y-6 p-12 ${tone === "error" ? "text-destructive" : ""}`}
    >
      {text}
    </div>
  );
}
